<template>
  <div class="settings-page">
    <div class="header shadow-sm">
      <div class="d-flex align-items-center">
        <van-button icon="arrow-left" class="border-0 bg-transparent" @click="$router.push('/admin')" />
        <h1 class="h5 mb-0 ml-2">Cấu hình Hệ thống</h1>
      </div>
      <div class="header-right">
         <span class="badge badge-primary">Phiên bản 1.0.0</span>
      </div>
    </div>

    <div class="content">
      <div class="settings-layout">
        <van-tabs v-model="activeTab" sticky animated swipeable color="#304ffe">
          <van-tab title="Hệ thống">
            <div class="tab-content">
              <SystemSettings 
                :data="settings.system" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>
          
          <van-tab title="Bán hàng">
            <div class="tab-content">
              <SalesSettings 
                :data="settings.sales" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Kho hàng">
            <div class="tab-content">
              <InventorySettings 
                :data="settings.inventory" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Tài chính">
            <div class="tab-content">
              <FinanceSettings 
                :data="settings.finance" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Khách hàng">
            <div class="tab-content">
              <CustomerSettings 
                :data="settings.customer" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Phân quyền">
            <div class="tab-content">
              <UserRoleSettings 
                :data="settings.user" 
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Hóa đơn & In">
            <div class="tab-content">
              <InvoicePrinterSettings 
                :data="settings.invoice" 
                :system-data="settings.system"
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>

          <van-tab title="Cấu hình In Phiếu">
            <div class="tab-content">
              <DebtReceiptSettings 
                :data="settings.debtReceipt" 
                :trans-data="settings.transactionReceipt"
                @update="handleUpdate" 
                @reset="handleReset"
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import SystemSettings from '../components/settings/SystemSettings.vue'
import SalesSettings from '../components/settings/SalesSettings.vue'
import InventorySettings from '../components/settings/InventorySettings.vue'
import FinanceSettings from '../components/settings/FinanceSettings.vue'
import CustomerSettings from '../components/settings/CustomerSettings.vue'
import UserRoleSettings from '../components/settings/UserRoleSettings.vue'
import InvoicePrinterSettings from '../components/settings/InvoicePrinterSettings.vue'
import DebtReceiptSettings from '../components/settings/DebtReceiptSettings.vue'

export default {
  name: 'Settings',
  components: {
    SystemSettings,
    SalesSettings,
    InventorySettings,
    FinanceSettings,
    CustomerSettings,
    UserRoleSettings,
    InvoicePrinterSettings,
    DebtReceiptSettings
  },
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    handleUpdate(section, payload) {
      if (section === 'user') {
          this.$emit('update-user-role', section, payload);
      } else {
          this.$emit('update-settings', section, payload);
      }
    },
    handleReset(section) {
      this.$emit('reset-settings', section);
    }
  }
}
</script>
